shared-black-over(class="{show: opts.show}" onClick="{this.onClick}")
  p shared black over!
  script(type="typescript").
    this.mixin('shared.black-over');
  style(scoped).
    :scope {
      width: 100%;
      height: 100%;
      background: #00000099;
      position: fixed;
      display: none;
      z-index: 1500;
      top: 0;
      left: 0;
    }
    :scope.show {
      display: block;
    }
